import { CourseStatus, ProductCardCta } from "./CourseTypes";


export type ProductCardMode =
  | "marketplace"
  | "owned"
  | "member"
  | "admin"
  | "preview";

export interface ProductCardProps {
  courseId: number;
  title: string;
  description: string;

  price?: string;
  rating?: number;
  instructor?: string;

  thumbnailImage?: string;
  bannerImage?: string;

  chaptersCount: number;
  totalDuration?: string;

  status: CourseStatus;
  mode: ProductCardMode;

  onPrimaryAction?: () => void;
  onSecondaryAction?: () => void;
}
export interface PublicProductCardDto {
  courseId: number;
  title: string;
  description: string;
  category: string;

  thumbnailImageUrl: string;
  bannerImageUrl?: string;

  price: string;
  rating: number;
  instructor: string;

  chaptersCount: number;
  enrolledUsers: number;
status: CourseStatus; 
  isOwned: boolean;
  isPurchasable: boolean;
  cta: ProductCardCta;
}
export interface ProductCardModel {
  courseId: number;
  title: string;
  description: string;

  thumbnailImage?: string;
  bannerImage?: string;

  price?: string;
  rating?: number;
  instructor?: string;
  status:CourseStatus;
  chaptersCount: number;
  enrolledUsers?: number;

  mode: ProductCardMode;
}
export const mapPublicProductCardToModel = (
  dto: PublicProductCardDto
): ProductCardModel => ({
  courseId: dto.courseId,
  title: dto.title,
  description: dto.description,
  thumbnailImage: dto.thumbnailImageUrl,
  bannerImage: dto.bannerImageUrl,
  price: dto.price,
  rating: dto.rating,
  instructor: dto.instructor,
  chaptersCount: dto.chaptersCount,
  enrolledUsers: dto.enrolledUsers,
status:dto.status,
  mode: dto.isOwned
    ? "owned"
    : dto.isPurchasable
    ? "marketplace"
    : "preview"
});
export const statusToLabel = (status: CourseStatus): string => {
  switch (status) {
    case CourseStatus.Published:
      return "Publicerad";
    case CourseStatus.Archived:
      return "Arkiverad";
    default:
      return "Utkast";
  }
};
export const getProductCardActions = (mode: ProductCardMode) => {
  switch (mode) {
    case "marketplace":
      return {
        primaryText: "Utforska",
        showPrice: true
      };

    case "owned":
      return {
        primaryText: "Gå till kurs",
        showPrice: false
      };

    case "member":
      return {
        primaryText: "Visa kurs",
        showPrice: false
      };

    case "admin":
      return {
        primaryText: "Hantera kurs",
        secondaryText: "Produktkort",
        showPrice: true
      };

    case "preview":
    default:
      return {
        showPrice: true,
        disabled: true
      };
  }
};
